<template>
  <BaseFilter
    :title="`${userModule.user} Filter`"
    :isChips="isChips"
    @submit="$emit('apply')"
    @reset="$emit('reset')"
    @filterDialogOpen="getBranchSelectList"
    :isIcon="false"
  >
    <template #form>
      <v-row no-gutters>
        <v-col cols="12" lg="6" xl="6" class="pt-2">
          <SelectField
            id="branch"
            name="branch"
            dense
            hide-details
            outlined
            clearable
            :label="`select ${configurationModule.branch}`"
            :itemsList="branchList"
            itemText="code"
            itemValue="id"
            :value="normalUserFilters.branch"
            class="pt-2 pl-1"
            :menu-props="{ offsetY: true }"
            @change="userFiltersChanged('branch', $event)"
          ></SelectField>
        </v-col>
      </v-row>
    </template>
  </BaseFilter>
</template>

<script>
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { bus } from "@/main";
import { configurationModule } from "@/utils/moduleMapping";
import { mapState } from "vuex";
import { userModule } from "@/utils/moduleMapping";
export default {
  components: {
    BaseFilter,
  },
  props: {
    value: Boolean,
    isChips: Boolean,
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      userModule,
      configurationModule,
      branchList: [],
    };
  },
  watch: {},
  computed: {
    ...mapState("userProfile", {
      normalUserFilters: (state) => state.normal_user_filters,
    }),
  },
  methods: {
    getBranchSelectList(params = {}) {
      bus.$emit("showLoader", true);
      this.$api.branch
        .getBranchSelectList({ ...params, limit: "all" })
        .then((res) => {
          bus.$emit("showLoader", false);
          this.branchList = res.data;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
        });
    },
    userFiltersChanged(key, value) {
      let obj = {};
      obj[key] = value;
      this.$store.commit("userProfile/setFilters", {
        moduleKey: "normal_user_filters",
        payload: obj,
      });
    },
  },
};
</script>
